import {updateSlideInList, setNewCurrentNode} from '../../utilities';
import {
  PROTOCOL_SLIDE_TYPES,
  fetchProtocolScene,
  SLIDE_NODE,
} from '@learningblocks/protocol-constants/lib/Utilities';

export function slideTwoRemoveDrop(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  const allSlides = updateAllSlides(protocolSection.allSlides, payload);
  return {
    ...protocolSection,
    allSlides,
  };
}

function updateAllSlides(allSlides, payload) {
  const slideTwo = fetchProtocolScene(allSlides, PROTOCOL_SLIDE_TYPES.TWO);
  const designSlideTwo = updateDesignSlideTwo(slideTwo, payload);
  const updatedAllSlides = updateSlideInList(allSlides, designSlideTwo);
  return updatedAllSlides;
}

function updateDesignSlideTwo(designSlideTwo, payload) {
  return {
    ...designSlideTwo,
    slideTree: updateSlideTree(designSlideTwo.slideTree, payload),
  };
}

function updateSlideTree(slideTree, payload) {
  const removeDropsInComponent = (component) => ({
    ...component,
    droppedId: null,
  });

  const removeDropsInNode = (node) => ({
    ...node,
    nodeComponents: node.nodeComponents.map(removeDropsInComponent),
  });

  const updateNodeComponent = (component) => {
    if (component.id === payload.positionID) {
      component.droppedId = null;
    }
    return {...component};
  };

  const updateChangedNode = (node) => ({
    ...node,
    nodeComponents: node.nodeComponents.map(updateNodeComponent),
  });

  const updateAllNodes = (node) => {
    if (node.nodeId === payload.nodeId) {
      node = updateChangedNode(node);
    }
    if (
      node.nodeId > payload.nodeId &&
      node.nodeType !== SLIDE_NODE.END_NODE &&
      node.nodeType !== SLIDE_NODE.JOINT_PATH_SELECT
    ) {
      node = removeDropsInNode(node);
    }
    return {...node};
  };

  const updateTreeGroup = (treeGroup) => ({
    ...treeGroup,
    groupNodes: treeGroup.groupNodes.map(updateAllNodes),
  });

  let updatedSlideTree = slideTree.map(updateTreeGroup);
  updatedSlideTree = setNewCurrentNode(updatedSlideTree);
  return updatedSlideTree;
}
